import {
  AnnouncementPriority,
  AnnouncementTargetRole,
  AnnouncementTargetType,
} from '../enums/announcement.enums'

/**
 * Policy actions for announcements
 */
export const ANNOUNCEMENT_POLICY_ACTIONS = {
  CREATE: 'announcement:create',
  VIEW: 'announcement:view',
  UPDATE: 'announcement:update',
  DELETE: 'announcement:delete',
  VIEW_ALL: 'announcement:viewAll',
} as const

export type AnnouncementPolicyAction =
  (typeof ANNOUNCEMENT_POLICY_ACTIONS)[keyof typeof ANNOUNCEMENT_POLICY_ACTIONS]

/**
 * Pagination configuration for announcements
 */
export const ANNOUNCEMENT_PAGINATION_CONFIG = {
  defaultPage: 1,
  defaultLimit: 20,
  maxLimit: 100,
} as const

/**
 * Error messages for announcements
 */
export const ANNOUNCEMENT_ERRORS = {
  NOT_FOUND: 'Announcement not found',
  ALREADY_EXISTS: 'Announcement already exists',
  UNAUTHORIZED: 'Not authorized to access this announcement',
  FORBIDDEN: 'Forbidden action on this announcement',
} as const

/** Options pour le sélecteur de priorité (formulaire annonce) */
export const ANNOUNCEMENT_PRIORITY_FORM_OPTIONS: {
  value: AnnouncementPriority
  label: string
}[] = [
  { value: AnnouncementPriority.LOW, label: 'Information' },
  { value: AnnouncementPriority.NORMAL, label: 'Normale' },
  { value: AnnouncementPriority.HIGH, label: 'Importante' },
  { value: AnnouncementPriority.URGENT, label: 'Urgente' },
]

/** Options pour le mode de ciblage (formulaire annonce) */
export const ANNOUNCEMENT_TARGET_TYPE_FORM_OPTIONS: {
  value: AnnouncementTargetType
  label: string
}[] = [
  { value: AnnouncementTargetType.ALL, label: 'Tout le monde' },
  { value: AnnouncementTargetType.ROLE, label: 'Par rôle' },
  { value: AnnouncementTargetType.CLASS, label: 'Par classe' },
]

/** Options pour le rôle cible (formulaire annonce) */
export const ANNOUNCEMENT_TARGET_ROLE_FORM_OPTIONS: {
  value: AnnouncementTargetRole
  label: string
}[] = [
  { value: AnnouncementTargetRole.STUDENT, label: 'Élèves' },
  { value: AnnouncementTargetRole.TEACHER, label: 'Enseignants' },
  { value: AnnouncementTargetRole.PARENT, label: 'Parents' },
]
